import { render, staticRenderFns } from "./pays_list.vue?vue&type=template&id=2cf89fc8&"
import script from "./pays_list.vue?vue&type=script&lang=js&"
export * from "./pays_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports